import { render, staticRenderFns } from "./PdfTable.vue?vue&type=template&id=0f7f86c5&"
import script from "./PdfTable.vue?vue&type=script&lang=js&"
export * from "./PdfTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports